import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useReferralStageStatus = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('manageReferralStageStatus', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: ['customerPointSetting', 'referralStage'] });
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync, isPending };
};

export default useReferralStageStatus;
